
import React, { useState } from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { TimePickerDemo } from './TimePicker';

interface TimeSelectorProps {
  register: any;
  setValue: (name: string, value: any) => void;
}

export const TimeSelector = ({ setValue }: TimeSelectorProps) => {
  const [time, setTime] = useState<string | undefined>(undefined);

  const handleTimeChange = (value: string) => {
    setTime(value);
    
    // Extract hours and minutes from time string
    const [hours, minutes] = value.split(':').map(Number);
    
    // Set the values in the form
    setValue('scheduledHour', hours);
    setValue('scheduledMinute', minutes);
  };

  return (
    <div className="space-y-2">
      <Label>Select Time</Label>
      <TimePickerDemo value={time} onChange={handleTimeChange} />
    </div>
  );
};
